

/**** 
 * cssFiltersForCanvas CONTAINS THE VARIOUS FILTERS THAT CAN BE APPLIES TO EDIT A VIDEO OR IMAGE
 * THE OBJECT CAN BE PASSED TO A FUNCTION 
 * BY DEFAULT, ALL THE CONTENT OF THE OBJECT WILL BE EVALUATED/USED BY THE FUNCTION 
 * BUT THIS CAN BE RESTRICTED BY CHANGING THE isNeeded TO FALSE FOR EACH ONE THAT IS NOT NEEDED
 * OR IS NOT RELEVANT TO THE FUNCTION 
 * 
 * onChangeFunc IS A FUNCTION THAT WILL BE CALLED WHEN THE USER CHANGES THE VALUE 
 * 
 * ****/

export 	const cssFiltersForCanvas = {

/*
	backgroundBlue: {
		property: "background-blur",
		text: smetioTxt.txt24,
		unit: "px",
		minValue: 0,
		maxValue: 100,
		defaultValue: 0,
		isNeeded: true,
		onChangeFunc: ""
	},
*/
	blur: {
		property: "blur",
		text: window.smetioTxts.txt15,
		unit: "px",
		minValue: 0,
		maxValue: 100,
		defaultValue: 0,
		isNeeded: true,
		onChangeFunc: ""
	},

	brightness: {
		property: "brightness",
		text: smetioTxt.txt16,
		unit: "%",
		minValue: 0,
		maxValue: 200,
		defaultValue: 100,
		isNeeded: true,
		onChangeFunc: ""			
	},

	contrast: {
		property: "contrast",
		text: smetioTxt.txt17,
		unit: "%",
		minValue: 0,
		maxValue: 200,
		defaultValue: 100,
		isNeeded: true,
		onChangeFunc: ""			
	},	

	grayscale: {
		property: "grayscale",
		text: smetioTxt.txt18,
		unit: "%",
		minValue: 0,
		maxValue: 100,
		defaultValue: 0,
		isNeeded: true,
		onChangeFunc: ""			
	},		

	hueRotate: {
		property: "hue-rotate",
		text: smetioTxt.txt19,
		unit: "deg",
		minValue: 0,
		maxValue: 360,
		defaultValue: 0,
		isNeeded: true,
		onChangeFunc: ""			
	},				

	invert: {
		property: "invert",
		text: smetioTxt.txt20,
		unit: "%",
		minValue: 0,
		maxValue: 100,
		defaultValue: 0,
		isNeeded: true,
		onChangeFunc: ""			
	},

	opacity: {
		property: "opacity",
		text: smetioTxt.txt21,
		unit: "%",
		minValue: 0,
		maxValue: 100,
		defaultValue: 100,
		isNeeded: true,
		onChangeFunc: ""			
	},	

	saturation: {
		property: "saturate",
		text: smetioTxt.txt22,
		unit: "%",
		minValue: 0,
		maxValue: 1000,
		defaultValue: 100,
		isNeeded: true,
		onChangeFunc: ""			
	},	

	sepia: {
		property: "sepia",
		text: smetioTxt.txt23,
		unit: "%",
		minValue: 0,
		maxValue: 100,
		defaultValue: 0,
		isNeeded: true,
		onChangeFunc: ""			
	}				

};